<template>
  <div id="nodes" class="min-center">
    <!-- <h2 class="theme"><i></i>节点</h2> -->
    <comtitle title = "节点"></comtitle>
    <div class="nodes-container">
      <div class="title">
        <span class="main-title">全球比特元的节点分布</span>
        <span class="sub-title"> 地图显示了世界各个国家及地区可到达比特元节点的集中度</span>
      </div>
      <div class="map">
        <nodes-map :nodesData="nodesData" :range="nodeNumRange" ref="nodesMap"></nodes-map>
      </div>
      <div class="display-wrap">
        <div class="info">
          <span class="total">{{totalNodes}}</span>
          <span class="type">个节点</span>
          <span class="describe">24H图表</span>
        </div>
        <p class="time-now">{{nowTime}}</p>
        <table style="width:100%;">
          <tr class="table-head">
            <th class="ranking">排名</th>
            <th class="country">国家或地区</th>
            <th>节点数</th>
          </tr>
          <tr v-show="isLoading">
            <td colspan="3"><beat-loader :loading="isLoading" :num="5"></beat-loader></td>
          </tr>
        </table>
        <table class="table-body" style="width:100%;">
          <tr v-for="(item, index) in nodesList" :key="item.name">
            <td class="ranking">{{index + 1}}</td>
            <td class="country">{{item.name}}</td>
            <td>{{item.value}}（{{item.percent}}）</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import comtitle from "@/components/comtitle.vue"
  import nodesMap from '@/components/map'
  import { myFetch } from '@/assets/js/api';
  import beatLoader from '@/components/beatLoader';
  import nodesBase from './node.base.js'

  export default {
    mixins: [nodesBase],
    data(){
      return{
        nodeNumRange: {
          max: 800,
          min: 0
        },
      }
    },
    components: {nodesMap, comtitle, beatLoader},
    methods: {
      getNodesInfo: function () {
        this.isLoading = true;
        let data = {
          "id": 1223,
          "method": "NetScan.PeersLocation",
          "params": []
        };
        myFetch(data,'/map').then((data)=>{
          this.netScanRespHandleBase(data);
          this.nodeNumRange.max = this.nodesList[0].value;
          this.nodeNumRange.min = this.nodesList[this.nodesList.length - 1].value;
          this.$refs.nodesMap.drawMap();
        })
      }
    }
    }
</script>

<style lang="scss" scoped>
 #nodes{
  height: 800px;
 }
 .nodes-container{
    margin: 12px 0 60px 0;
    // box-shadow: rgba(185, 185, 185, 0.45) 0px 0px 7px ;
    .title{
      height: 75px;
      line-height: 75px;
      .main-title{
        display: inline-block;
        font-size: 18px;
        margin: 0 10px 0 14px;
      }
      .sub-title{
        font-size: 14px;
        color: #838B9E;
      }
    }
  }
  .map{
    float: left;
    height: 583px;
    min-width: 700px;
  }
  .display-wrap{
    margin-left: 700px;
    height: 585px;
    max-width: 740px;

  }
  .info{
    padding: 23px 0 24px 70px;
    .total{
      font-size: 30px;
      color: #D9A73A;
    }
    .type{
      font-size: 18px;
      color: #8E8E8E;
    }
    .describe{
      display: inline-block;
      margin-left: 9px;
      font-size: 14px;
      color: #999;
    }
  }
  .time-now{
    padding: 0 0 24px 70px;
    font-size: 14px;
  }
 ::-webkit-scrollbar {display:none}
 table{
    display: block;
    padding: 0 20px;
    margin: 0 auto;
    text-align: center;
    .table-head{
      font-size: 16px;
      line-height: 40px;
    }
    .table-head{
      height:60px;
      th{
        text-align: center;
      }
    }
    th:nth-of-type(1),td:nth-of-type(1){
      min-width:100px;
      width: 150px;
    }
    th:nth-of-type(2),td:nth-of-type(2){
      min-width:150px;
      width: 380px;
    }
    th:nth-of-type(3),td:nth-of-type(3){
      min-width:100px;
    }
  }

  .table-body{
     height: 390px;
     overflow-y: auto;
     tr{
      width: 100%;
       font-size: 14px;
       line-height: 40px;
     }
  }
</style>

<style lang="scss">
  .nodes-container{
    background-color: #2E2D2E;
    .main-title{
        color: #fff;
    }
    .info{
      border-top: 1px solid #3A393A;
    }
    .time-now{
      color: #DADADA;
      border-bottom: 1px solid #3A393A;
    }
    .map{
      background: #313031;
      background-image: linear-gradient(transparent 90%, #464547 90%), linear-gradient(to right, transparent 90%, #464547 90%);
      background-size: 10px 10px;
    }
  }
  .table-body tr{
    color: #fff;
  }
  .table-head{
    color: #8E8E8E;
  }
</style>